import React from 'react';
import projects from '../data.json';
import Project from '../Components/project';

const Projects = () => {
	return (
		<>
			<section className="projects">
				<div className="projects_wrapper">
					<div className="projects_heading">
						<h2>Recent Projects</h2>
					</div>
					<div className="projects_group">
						{projects.projects.map((project, index) => {
							return (
								<Project
									key={project.id}
									project={project}
									side={index % 2 === 0 ? 'left' : 'right'}
								/>
							);
						})}
					</div>
				</div>
			</section>
		</>
	);
};

export default Projects;
